import type { AnswerValue, Question } from '../../lib/types';
import { cx, fileUrl } from '../../lib/utils';
import { QuestionInput } from './QuestionInput';

interface Props {
  question: Question;
  number: number;
  value: AnswerValue | undefined;
  onChange: (value: AnswerValue) => void;
  error?: string;
  slug?: string;
  disabled?: boolean;
}

/** One question as the client sees it: number, text, help, image, scenario quote and input. */
export function QuestionBlock({ question: q, number, error, ...input }: Props) {
  const inputId = `q-${q.id}`;
  const isGroup =
    q.type === 'single_choice' || q.type === 'multiple_choice' || q.type === 'file_upload';
  const Label = isGroup ? 'p' : 'label';

  return (
    <div className={cx('question', error && 'has-error')} id={`question-${q.id}`}>
      <Label className="question-label" {...(isGroup ? {} : { htmlFor: inputId })}>
        <span className="question-number">{number}</span>
        <span>
          {q.label}
          {q.required ? (
            <span className="required" aria-label="required">
              {' '}
              *
            </span>
          ) : (
            <span className="optional"> (optional)</span>
          )}
        </span>
      </Label>
      {q.description && <p className="question-description">{q.description}</p>}
      {q.imageId && (
        <img className="question-image" src={fileUrl(q.imageId)} alt="" loading="lazy" />
      )}
      {q.quote && <blockquote className="quote">{q.quote}</blockquote>}
      <QuestionInput question={q} error={error} {...input} />
      {error && (
        <p className="error-text" id={`${inputId}-error`}>
          {error}
        </p>
      )}
    </div>
  );
}
